import * as yup from "yup";

export const NJUSKALO_EDIT_FORM_SCHEMA = yup.object().shape({
  username: yup
    .string()
    .required("Molimo Vas da unesete korisničko ime"),
  password: yup
    .string()
    .required("Molimo Vas da unesete lozinku"),
});
